import React from "react";
import { MainContainer } from "../../components/ContentWrapper";
import { PageTitle } from "../../components/PageTitle";
import { ReactComponent as VideoIcon } from "../../assets/svg/icon-video.svg";
import { ReactComponent as HelpIcon } from "../../assets/svg/icon-help-circle.svg";
import { ReactComponent as FileIcon } from "../../assets/svg/icon-doc-lines.svg";
import { ReactComponent as DocCardIcon } from "../../assets/svg/icon-doc-card.svg";
import { ReactComponent as DownloadIcon } from "../../assets/svg/icon-download-arrow.svg";
import { EXPERT_VIDEOS, FAQS, PRODUCTION_FAQ_DOC, renderFaqAnswer } from "./helper";
import { FaqList } from "../../components/FaqList/FaqList";
import { VideoGrid } from "../../components/VideoGrid/VideoGrid";

export default function ExpertResourcesPage() {
    return (
        <MainContainer>
            <div className="flex flex-col gap-6">
                <PageTitle title="Expert Resources" />

                <div className="w-full flex flex-col" style={{ fontFamily: "'CircularStd', 'DM Sans', sans-serif" }}>
                    <section className="py-5">
                        <div className="flex items-center gap-2.5 mb-3.5 text-sm font-semibold text-text-1 [&>svg]:text-accent [&>svg]:shrink-0">
                            <VideoIcon width={22} height={22} />
                            Videos
                        </div>
                        <VideoGrid videos={EXPERT_VIDEOS} />
                    </section>

                    <div className="h-px bg-border-token" />

                    <section className="py-5">
                        <div className="flex items-center gap-2.5 mb-3.5 text-sm font-semibold text-text-1 [&>svg]:text-accent [&>svg]:shrink-0">
                            <HelpIcon width={22} height={22} />
                            TDC Production FAQ's
                        </div>
                        <FaqList items={FAQS} defaultOpenId={3} renderAnswer={renderFaqAnswer} />
                    </section>

                    <div className="h-px bg-border-token" />

                    <section className="py-5">
                        <div className="flex items-center gap-2.5 mb-3.5 text-sm font-semibold text-text-1 [&>svg]:text-accent [&>svg]:shrink-0">
                            <FileIcon width={22} height={22} />
                            Documents
                        </div>
                        <div className="flex items-center gap-3 px-3.5 py-3 bg-surface-2 border border-border-token rounded-[10px] transition-colors hover:border-accent">
                            <div className="w-[38px] h-[38px] rounded-lg bg-[#FBE9E7] flex items-center justify-center shrink-0 text-[#C62828]">
                                <DocCardIcon width={18} height={18} />
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="text-[13px] font-semibold text-text-1">{PRODUCTION_FAQ_DOC.name}</div>
                                <div className="text-[11px] text-text-2 mt-px">{PRODUCTION_FAQ_DOC.meta}</div>
                            </div>
                            <a
                                href={PRODUCTION_FAQ_DOC.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                download={PRODUCTION_FAQ_DOC.filename}
                                aria-label="Download document"
                                className="w-8 h-8 rounded-full border border-border-token bg-surface flex items-center justify-center cursor-pointer text-muted shrink-0 transition-all no-underline hover:border-accent hover:text-accent-text"
                            >
                                <DownloadIcon width={16} height={16} />
                            </a>
                        </div>
                    </section>
                </div>
            </div>
        </MainContainer>
    );
}
